import gql from 'graphql-tag';

export const GET_PERSONAL_STATEMENT_SUMMARY = gql`
  query getPersonalStatementSummary($schoolName: String!) {
    personal_statements(where: {
        schools: {
            _contains: [
                {
                    label: $schoolName
                }
            ]
        }
    }) {
        id
        name
        status
        documents {
            document {
                filename
                url
            }
        }
        user {
            user_id
            name
        }
    }
  }
`

export const GET_SUPPLEMENT_STATEMENT_SUMMARY = gql`
    query getSupplementalStatementSummary($schoolName: String!) {
        universities(where: {
            schools: {
                _contains: [{
                    label: $schoolName
                }]
            }
        }) {
            id
            university_name
            schools
            user {
                name
            }        
            documents {
                id
                filename
                status
                url
            }
        }
    }
`;